import React from 'react';

export default function MuiAgg({ aggregatorList, aggregatorName, vals, onClickAdd, onDeleteItem, getMessage }) {
    return <></>;
}
